import { COUNTRY } from '@/core/country.js';
import store from '@/store';
import { validate as validateAU } from './au';
import {
  validate as validateUK,
  validateOneDocument as validateOneUkDocument,
} from './uk';
import { validateAdditionalQuestions as validateQuestion } from './common/custom-questions';

function createAdditionalQuestionValidator() {
  return validateQuestion;
}

function createCountryBasedValidator() {
  const countryCode = store.state.onboarding?.countryCode;
  let validator;
  switch (countryCode) {
    case COUNTRY.AU:
      validator = validateAU;
      break;
    case COUNTRY.GB:
      validator = validateUK;
      break;
    default:
      validator = validateAU;
      break;
  }
  return validator;
}

function validatorFactory(fieldType) {
  switch (fieldType) {
    case 'CUSTOM_QUESTION':
      return createAdditionalQuestionValidator();
    default:
      return createCountryBasedValidator();
  }
}

export async function validate(field) {
  let validator = validatorFactory(field.type);
  const validationResult = await validator(field);
  field.fieldError = validationResult;
  field.isInvalid = Boolean(validationResult);
}

export async function validateOneWholeDocument(document, changedField) {
  const countryCode = store.state.onboarding?.countryCode;

  let validator;
  switch (countryCode) {
    case COUNTRY.GB:
      validator = validateOneUkDocument;
      break;
    default:
      validator = null;
      break;
  }

  if (!validator) {
    return true;
  }

  const errorMap = await validator(document, changedField);
  if (errorMap === null) {
    return true;
  }

  const hasError = Object.keys(errorMap).some((item) => errorMap[item]);
  let canSave = false;

  if (!hasError) {
    canSave = true;
  }

  // inject / clear error messages at document
  document.fields.forEach((field) => {
    field.fieldError = '';
    if (field.name in errorMap) {
      field.fieldError = errorMap[field.name];
      field.isInvalid = Boolean(field.name);
    }
  });

  return canSave;
}
